export enum PopupTitlesTypes {
  Info,
  Warning,
  Confirm,
}
